export const UID = 'uid';
export const URL = 'url';
export const TITLE = 'title';

export const FIRST_NAME = 'first_name';
export const LAST_NAME = 'last_name';
export const EMAIL_ADDRESS = 'email';
export const PHONE_NUMBER = 'phone';
